module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sky-crop"
  }, _vm._l((_vm.imageArray), function(image) {
    return _c('img', {
      staticClass: "element",
      style: (image.styling),
      attrs: {
        "src": image.src,
        "alt": _vm.alt
      },
      on: {
        "load": _vm.removeOldElement
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-85e3e0f0"}!./scripts/sky-crop/sky-crop.html
// module id = 380
// module chunks = 1